import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { _FunctionalArea, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { SelectFunctionalID } from "../functionalID/SelectFunctionalID";
import { AppointmentEditor } from "../../../Talentohumano/ParametrosTalentoHumano/Appointment/Appointment.editor";
import { ConstractStateEditor } from "../../../Talentohumano/GestionTH/EmployeeContract/ComponentsContract/EditorsEmployeContrac/ConstractState.editor";
import { FunctionalAreeaStateEditor } from "./FunctionalAreeaState.editor";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { SelectSiteID } from "../SiteID/SelectSiteID";
import { AppointmentManualEditor } from "../../../Talentohumano/ParametrosTalentoHumano/AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../../../Talentohumano/ParametrosTalentoHumano/AppointmentGroupManual/AppointmentGroupManual.editor";
import { ARPRiskEditor } from "../../../Talentohumano/GestionTH/EmployeeContract/ComponentsContract/EditorsEmployeContrac/ARPRisk.editor";
import { EmploymentTypeEditor } from "../../../Talentohumano/GestionTH/EmployeeContract/ComponentsContract/EditorsEmployeContrac/EmploymentType.editor";
import { EmployeeContractTypeEditor } from "../../../Talentohumano/GestionTH/EmployeeContract/ComponentsContract/EditorsEmployeContrac/EmployeeContractType.editor";
import { CostingCenterSelect } from "../../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { EntailmentEditor } from "../../../Talentohumano/ParametrosTalentoHumano/Entailment/Entailment.editor";
import { SelectBusinessCore } from "../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectLabourTypeConstants } from "../../../Factoty&Production/LabourType/SelectLabourTypeConstants";
import usePaginator from "../../../theme/Component/usePaginator";
import { InputDate } from "../../../theme/Input/InputDate";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";
import { DropDown } from "../../../theme/Component/DropDown";
import { SelectProject } from "../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { _ModifyLaboral, _ModifyLevel } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { EmployeeHistoryEditor } from "../../../Talentohumano/GestionTH/EmployeeContract/EmployeeHistoryEditor/EmployeeHistoryEditor";
import { EmployeeByFunctional } from "./EmployeeByFunctional/EmployeeByFunctional";
import { AppointmentCatalog } from "../../../Talentohumano/ParametrosTalentoHumano/Appointment/AppointmentCatalog/AppointmentCatalog";
import useModal, { MODAL_LG, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { LaboralPosition } from "./LaboralPosition/LaboralPosition";

interface form {
    State: number;
    Name: string;
    IDLnFunctional: number;
    Appointment: number;
    StateContract: number;
    IDAccount: number;
    Rows: number
}

export const FunctionalArea = () => {

    const functionalArea = useDataBean(_FunctionalArea);
    const modifylevel = useDataBean(_ModifyLevel);
    const modifylaboral = useDataBean(_ModifyLaboral);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [date, setdate] = useState<any>(_single.getCurrenDate());
    const [IDLn, setIDLn] = useState<any>(null);
    const [modalhistory, setModalhistory] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalmodifylevel, setModalmodifylevel] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalmodifylaboral, setModalmodifylaboral] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();
    const [listaExport, setListaExport] = useState([]);
    const [modalCSV, setModalCSV] = useState<any>({ name: 'Reporte', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-sm' });

    const modalPosition = useModal("Posiciones laborales Disponibles", MODAL_LG);

    const [formResponse, setFormResponse] = useState<Partial<form>>({
        Rows: 15,

    })
    const [group, setGroup] = useState<number>(null);

    const [missingFields, setMissingFields] = useState<string[]>([]);

    useEffect(() => {
        if (paginador.page > 0) {
            getLista();
        }
    }, [paginador.page])

    const getListaExport = () => {
        functionalArea.instance.getFunctionalAreaCatalogvdos(IDLn, formResponse.State, formResponse.Name, formResponse.IDLnFunctional, formResponse.Appointment, formResponse.StateContract, formResponse.IDAccount, date, 1, paginador.pages * 15).then(
            (resp) => {
                setListaExport(resp.List)
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se pudo realizar la consulta")
            }
        )
    }


    const getLista = () => {

        functionalArea.instance.getFunctionalAreaCatalogvdos(IDLn, formResponse.State, formResponse.Name, formResponse.IDLnFunctional, formResponse.Appointment, formResponse.StateContract, formResponse.IDAccount, date, paginador.page, formResponse.Rows).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (formResponse.Rows ?? 15));
                paginador.setRegiPerPage(formResponse.Rows)

                setLista(resp.List)
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se pudo realizar la consulta")
            }
        )
    }

    const setAppointmentToEmployeeContract = () => {
        modifylevel.instance.setAppointmentToEmployeeContract(functionalArea.bean.IDContract, modifylevel.bean.IDAppointment, modifylevel.bean.Date, _single.getAccountID()).then(
            (resp) => {
                console.log(resp)
                setModalmodifylevel({ ...modalmodifylevel, "view": false })
            }
        ).catch(
            err => {
                console.log(err)
                toast.error(err)
            }
        )
    }
    const setFunctionalAreaToEmployeeContract = () => {
        modifylaboral.instance.setFunctionalAreaToEmployeeContract(modifylaboral.bean.IDContract, modifylaboral.bean.Date, functionalArea.bean.IDLn, _single.getAccountID()).then(
            (resp) => {
                setModalmodifylaboral({ ...modalmodifylaboral, "view": false })
                console.log(resp)
            }
        ).catch(
            err => {
                console.log(err)
                toast.error(err)
            }
        )
    }
    const create = () => {
        functionalArea.setBean({
            State: 3,
        })
        setModal({ ...modal, "name": "Agregar Plaza Laboral", "view": true })
    }

    const deleteItem = () => {
        functionalArea.deleteItemVoid(functionalArea.bean.IDLn).then(
            (resp) => {
                //console.log(resp)
                setModalC({ ...modalC, "view": false })
                getLista();
            }
        )
    }

    const editaItem = () => {
        let x = functionalArea.bean;
        x.IDEmployeeLastUpdate = single.getAccountID();
        //console.log(x)
        functionalArea.update().then(
            (resp) => {
                //console.log(resp)
                getLista()
                setModal({ ...modal, "view": false })
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDLn', mask: MASK_NUMBER, visible: true },
        { title: 'Estado de la Plaza', property: 'StateName', visible: true },
        { title: 'Tipo de Labor', property: 'LabourTypeName', visible: true },
        { title: 'Código Posición Jerárquica', property: 'FunctionalIDCode', visible: true },
        { title: 'Nombre Posición Jerárquica', property: 'FunctionalIDName', visible: true },
        { title: 'Código', property: 'Code', mask: MASK_NUMBER, visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Manual de Funciones', property: 'AppointmentManualName', visible: true },
        { title: 'Proyecto', property: 'ProjectName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: false },
        { title: 'Nivel Jerárquico', property: 'EntailmentName', visible: false },
        { title: 'Nivel Salarial', property: 'AppointmentName', visible: true },
        { title: 'Ubicación Geográfica de la Plaza', property: 'SiteIDName', visible: false },
        { title: 'Manual de Perfil y Funciones del Cargo', property: 'AppointmentManualName', visible: false },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: false },
        { title: 'Área de Negocio', property: 'BusinessCoreName', visible: false },
        { title: 'Riesgo Laboral', property: 'ARPRiskName', visible: false },
        { title: 'Unidad Organizacional', property: 'FunctionalIDName', visible: false },
        // { title: 'Codigo Área', property: 'FunctionalIDCode', visible: true },
        // { title: 'Área', property: 'FunctionalIDName', visible: true },
        { title: 'IDContrato Laboral', property: 'IDContract', mask: MASK_NUMBER, visible: true },
        { title: 'Empleado', property: 'FunctionalAreaName', visible: false },
        { title: 'Empleado', property: 'AccountName', visible: true },
        { title: 'Titular Plaza', property: 'AccountHolderName', visible: true },
        { title: 'Fecha Inicio', property: 'InitContract', visible: true },
        { title: 'Fin del Contrato', property: 'UptoContract', visible: false },
        { title: 'Estado del Contrato', property: 'ContractStateName', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: false },
        { title: 'Fecha de Creación', property: 'Since', mask: MASK_DATE, visible: true },
        { title: 'Última actualización', property: 'LastUpdateEmployeeName', visible: true },
        { title: 'Fecha Última Actualización', property: 'LastUpdate', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Historial de Contratos de Trabajo', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalhistory({ ...modalhistory, "view": true }) } },
            { titulo: 'Modificar Nivel Salarial', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalmodifylevel({ ...modalmodifylevel, "view": true }) } },
            { titulo: 'Modificar Plaza Laboral', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalmodifylaboral({ ...modalmodifylaboral, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar Plaza Laboral`, "view": true }) } },
            { titulo: 'Posiciones Laborales', icono: 'ri-list-check', visible: single.canEdit(), evento: () => { modalPosition.open(); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Name", "IDAppointment", "IDLnSiteID", "IDLnFunctionalID",
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (functionalArea.bean[field] === null || functionalArea.bean[field] === undefined || functionalArea.bean[field] === "") {
                missing.push(field);
            }
        }

        //console.log(missing)
        setMissingFields(missing);
        return missing.length
    };

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }

                </div>
            </div>
        )
    }

    const actions = (e: any) => {

        if (e.id === 1) {
            getListaExport();
            setModalCSV({ ...modalCSV, "view": true });
        }
    }

    return (
        <>
            <BasicPage titulo="Plazas/Puestos Laborales">
                <div className="row">
                    <div className="col-4">
                        <label>ID de Plaza Laboral</label>
                        <input type="text" className="form-control" value={IDLn} onChange={(e) => { setIDLn(e.target.value) }} />
                    </div>
                    <div className="col-4">
                        <FunctionalAreeaStateEditor label="Estado" idSelector={formResponse.State} onChange={(e) => { setFormResponse({ ...formResponse, State: e }) }} />
                    </div>
                    <div className="col-4">
                        <label>Nombre de la plaza</label>
                        <input type="text" className="form-control" value={formResponse.Name} onChange={(e) => { setFormResponse({ ...formResponse, Name: e.target.value }) }} />
                    </div>
                    <div className="col-md-4">
                        <InputDate name="date" label="Fecha a consultar" value={date} setDate={(e: any) => { setdate(e) }} />
                    </div>
                    <div className="col-4">
                        <SelectFunctionalID label="Unidad Organizacional" onChange={(e) => { setFormResponse({ ...formResponse, IDLnFunctional: e?.IDLn }) }} />
                    </div>
                    <div className="col-4">
                        <AppointmentEditor label="Nivel Salarial" idSelector={formResponse.Appointment} onChange={(e) => { setFormResponse({ ...formResponse, Appointment: e }) }} />
                    </div>
                    <div className="col-4">
                        <ConstractStateEditor idSelector={formResponse.StateContract} onChange={(e) => { setFormResponse({ ...formResponse, StateContract: e }) }} />
                    </div>
                    <div className="col-md-4">
                        <AccountEditor idAccount={formResponse.IDAccount} onChange={(e) => { setFormResponse({ ...formResponse, IDAccount: e.IDAccount }) }} label="Tercero" />
                    </div>

                    <div className="col-12 mt-4">
                        <BasicButton icon="ri-search-line" eventClick={getLista}>Buscar</BasicButton>
                    </div>

                </div>
                <div className="row">
                    <BasicTable
                        headButtons={buttons()}
                        iconButtons={iconButtonsItem}
                        listButtons={listaBotones()}
                        body={lista}
                        head={head}
                        rowSet={functionalArea.setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />
                </div>
                <div className="col-md-12">
                    <Modal modal={modalmodifylevel} updateModal={setModalmodifylevel} eventModal={setAppointmentToEmployeeContract}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Nivel Salarial</label>
                                <AppointmentCatalog render={modifylevel.bean.Name} idSelector={modifylevel.bean.IDAppointment} onChange={(e) => { modifylevel.setBean({ ...modifylevel.bean, "IDAppointment": e.IDAppointment, "Name": e.Name }) }} label=" " returnType="Object" />
                                {/* <AppointmentEditor seeMoney label="Nivel Salarial" idSelector={modifylevel.bean.IDAppointment} onChange={(e) => { modifylevel.setBean({ ...modifylevel.bean, "IDAppointment": e }) }} /> */}
                            </div>
                            <div className="col-md-6">
                                <InputDate notDate label="Fecha Desde" name="Date" value={modifylevel.bean.Date} setDate={(e) => { modifylevel.setBean({ ...modifylevel.bean, "Date": e }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalmodifylaboral} updateModal={setModalmodifylaboral} eventModal={setFunctionalAreaToEmployeeContract}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Contrato laboral</label>
                                <EmployeeHistoryEditor render={modifylaboral.bean.IDContractName} idSelector={modifylaboral.bean.IDContract} onChange={(e) => { modifylaboral.setBean({ ...modifylaboral.bean, "IDContract": e.IDContract, "IDContractName": e.IDContract }) }} label=" " returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <InputDate notDate label="Fecha Desde" name="Date" value={modifylaboral.bean.Date} setDate={(e) => { modifylaboral.setBean({ ...modifylaboral.bean, "Date": e }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalhistory} updateModal={setModalhistory}>
                        <div className="row">
                            <EmployeeByFunctional IDLn={functionalArea.bean.IDLn} />
                        </div>
                    </Modal>
                </div>
            </BasicPage>

            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={validateData} >
                    <div className="row">
                        {/* <div className="col-md-12">
                            <SelectProject label='Proyecto' idSelector={functionalArea.bean.IDProject} returnType="Object" onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDProject": e.IDProject }) }} />
                        </div> */}
                        <div className="col-md-6">
                            <label>Código</label>
                            <input type="number" name="Code" className="form-control" value={functionalArea.bean.Code} onChange={functionalArea.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`}>Nombre</label>
                            <input type="text" name="Name" className="form-control" value={functionalArea.bean.Name} onChange={functionalArea.handleChange} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={functionalArea.bean.Description} onChange={functionalArea.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Tipo de Labor</label>

                            <SelectLabourTypeConstants label=" " idSelector={functionalArea.bean.LabourType} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "LabourType": e }) }} />
                            {/* <input type="number" name="LabourType" className="form-control" value={functionalArea.bean.LabourType} onChange={functionalArea.handleChange} /> */}
                        </div>
                        <div className="col-6">
                            <label className={`${missingFields.includes('IDLnSiteID') ? 'has-error' : ''}`}>Ciudad</label>
                            <SelectSiteID edit idLnSite={functionalArea.bean.IDLnSiteID} label=" " onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDLnSiteID": e.IDLn }) }} />
                        </div>
                        
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDAppointment') ? 'has-error' : ''}`}>Nivel Salarial</label>
                            <AppointmentEditor seeMoney label=" "
                                idSelector={functionalArea.bean.IDAppointment}
                                returnType="Object"
                                onChange={(e) => { console.log(e); functionalArea.setBean({ ...functionalArea.bean, "IDAppointment": e.IDAppointment, IDEntailment: e.IDEntailment }) }} />
                        </div>
                        <div className="col-md-6">
                            <EntailmentEditor label="Nivel Jerárquico" idSelector={functionalArea.bean.IDEntailment} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDEntailment": e }) }} />
                        </div>
                        <div className="col-6">
                            <AppointmentGroupManualEditor idSelector={group} onChange={(e) => { setGroup(e) }} />
                        </div>
                        <div className="col-6">
                            <AppointmentManualEditor appoGroup={group} idSelector={functionalArea.bean.IDAppointmentManual} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDAppointmentManual": e }) }} />
                        </div>
                        <div className="col-6">
                            <CostingCenterSelect fKey="Code" label="Centro de Costo" idSelector={functionalArea.bean.CostingCenterCode} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "CostingCenterCode": e }) }} />
                        </div>
                        <div className="col-6">
                            <label className={`${missingFields.includes('IDLnFunctionalID') ? 'has-error' : ''}`}>Unidad Organizacional</label>
                            <SelectFunctionalID label=" " functionalIDLn={functionalArea.bean.IDLnFunctionalID} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDLnFunctionalID": e?.IDLn }) }} />
                        </div>
                        {/* <div className="col-6">
                            <ARPRiskEditor label='Riesgo Laboral' idSelector={functionalArea.bean.ARPRisk} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "ARPRisk": e }) }} />
                        </div> */}
                        <div className="col-md-6">
                            <AccountEditor label="Titular Plaza" idAccount={functionalArea.bean.IDAccountHolder} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDAccountHolder": e.IDAccount }) }}></AccountEditor>
                        </div>
                        <div className="col-md-6">
                            <SelectBusinessCore label='Área de Negocio' returnType="Object" idSelector={functionalArea.bean.IDBusinessCore} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDBusinessCore": e.IDBusinessCore, "BusinessCoreCodeName": `${e.Code} - ${e.Name}` }) }} />
                        </div>
                        <div className="col-6">
                            <EmploymentTypeEditor idSelector={functionalArea.bean.IDEmploymentType} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDEmploymentType": e }) }} />
                        </div>
                        <div className="col-6">
                            <EmployeeContractTypeEditor idSelector={functionalArea.bean.IDEmployeeContractType}
                                onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDEmployeeContractType": e }) }} />
                        </div>
                        <div className="col-6">
                            <FunctionalAreeaStateEditor idSelector={functionalArea.bean.State}
                                onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "State": e }) }} />
                        </div>

                        {/* <PrintJson json={functionalArea.bean} /> */}
                    </div>
                </Modal>
            }

            {modalC.view &&
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    Esta seguro de eliminar {functionalArea.bean.Name}
                </ModalConfirm>
            }
            <Modal modal={modalCSV} updateModal={setModalCSV}>
                <div className="row">
                    <div className="col">
                        {listaExport.length > 0 &&
                            <ExportXLSL customName={"Plazas Laborales"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                            }} />
                        }
                    </div>
                </div>
            </Modal>

            <Modal modal={modalPosition.modal} updateModal={modalPosition.setModal} >
                <LaboralPosition ObjfunctionalID={functionalArea.bean} />
            </Modal>
        </>
    )
}